import type {Role} from '@redstack/shared'
import {apiClient} from './client'

export type DevUser = {
	id: string
	email: string | null
	firstName: string | null
	lastName: string | null
	role: Role
	avatarUrl: string | null
	externalId: string
	organization: {
		id: string
		name: string
		slug: string
		archivedAt: string | null
	} | null
}

export async function getDevUsers(): Promise<{data: DevUser[]}> {
	return apiClient<{data: DevUser[]}>('/api/dev/users')
}
